import 'air-datepicker';
import Typed from 'typed.js';

const chat = $('.chatbot');
const startTime = 3000;
let isDated = false;
let isCounted = false;
let isPhoned = false;
let isNamed = false;
let isThxed = false;
let isSent = false;

function chatBot() {
  const widget = $('.chatbot-widget');
  const getCountGuests = (number) => {
    return `${number} ${declinationGuests(number, [
      'Гость',
      'Гостя',
      'Гостей',
    ])}`;
  };

  const getCountKids = (number) => {
    return `${number} ${declinationGuests(number, ['год', 'года', 'лет'])}`;
  };

  let guest = {
    date: null,
    persons: null,
    phone: null,
    name: null,
  };
  let adults = 1;
  let kids = 0;
  let persons = 1;
  let personsAnswer = $('#guest-total');
  let adultVal = $('.chatbot-adults__number');
  let minusButton = $('.chatbot-adults__minus');
  let kidsAge = $('.chatbot-kids-age');
  let kidsTable = $('.chatbot-kids-added');
  let submitPersonsButton = $('#submit-persons');
  let guestPhone = $('#guest-phone');
  let guestName = $('#guest-name');
  let addKidButton = $('#add-kid');

  initDatePicker();
  go();

  function go() {
    let step = 0;
    let totalSteps = Object.keys(guest).length;

    for (let key in guest) {
      if (guest[key] === null) {
        chat.attr('data-step', key);
        goNext(key);
        break;
      }

      step++;

      if (step === totalSteps) goNext();
    }
  }

  function goNext(step) {
    switch (step) {
      case 'date':
        setDate(step);
        break;
      case 'persons':
        setPersons(step);
        break;
      case 'phone':
        setPhone(step);
        break;
      case 'name':
        setName(step);
        break;
      default:
        thxUser();
        sendUserData();
        break;
    }
  }

  function initDatePicker() {
    let userDatesAnswer = $(`.is-guest[data-step="date"]`);

    $('.js-dateTrip').datepicker({
      range: true,
      inline: true,
      minDate: new Date(),
      multipleDatesSeparator: ' по ',
      toggleSelected: false,
      showOtherMonths: false,

      onSelect: function (formattedDate, date, datepicker) {
        let $areAllDates = datepicker.selectedDates.length == 2;

        if ($areAllDates) {
          userDatesAnswer.show();
          $('.guest-date').val(`c ${formattedDate}`);
          scrollToBot();

          guest.date = {
            from: datepicker.selectedDates[0].toLocaleDateString(),
            to: datepicker.selectedDates[1].toLocaleDateString(),
          };

          go();
        }
      },
    });
  }

  function setDate(step) {
    let bot = $(`.is-bot[data-step="${step}"]`);
    let printStatus = $('#print-date');
    let datepicker = $('.datepicker-inline');

    bot.show();

    if (!isDated) {
      new Typed('#type-date', {
        stringsElement: '#text-date',
        typeSpeed: 10,
        backSpeed: 0,
        startDelay: 1000,
        loop: false,
        onBegin: function (self) {
          setTimeout(() => printStatus.show(), self.startDelay);
        },
        onComplete: function () {
          printStatus.hide();
          datepicker.fadeIn();
          scrollToBot();
        },
      });
    }

    isDated = true;
  }

  function setPersons(step) {
    let bot = $(`.is-bot[data-step="${step}"]`);
    let printStatus = $('#print-persons');
    let personsWidget = $('.chatbot-persons');

    bot.show();
    if (!isCounted) {
      new Typed('#type-persons', {
        stringsElement: '#text-persons',
        typeSpeed: 10,
        backSpeed: 20,
        startDelay: 1000,
        loop: false,
        onBegin: function (self) {
          setTimeout(() => printStatus.show(), self.startDelay);
        },
        onComplete: function () {
          printStatus.hide();
          personsWidget.fadeIn();
          scrollToBot();
        },
      });
    }

    isCounted = true;
  }

  function setPhone(step) {
    let bot = $(`.is-bot[data-step="${step}"]`);
    let user = $(`.is-guest[data-step="${step}"]`);
    let printStatus = $('#print-phone');
    let answer = $(`.chatbot-answer[data-step="${step}"]`);
    let answerInput = answer.find('input');
    let answerButton = answer.find('button');

    bot.show();
    scrollToBot();

    if (!isPhoned) {
      new Typed('#type-phone', {
        stringsElement: '#text-phone',
        typeSpeed: 10,
        backDelay: 20,
        startDelay: 1000,
        loop: false,
        contentType: 'html',
        loopCount: null,
        onBegin: function (self) {
          setTimeout(() => printStatus.show(), self.startDelay);
        },
        onComplete: function () {
          printStatus.hide();
          answer.fadeIn();
          scrollToBot();
        },
      });
    }

    isPhoned = true;

    answerButton.on('click', () => {
      guestPhone.val(answerInput.val());
      guest.phone = answerInput.val();
      answer.hide();
      user.show();
      scrollToBot();
      go();
    });
  }

  function setName(step) {
    let bot = $(`.is-bot[data-step="${step}"]`);
    let user = $(`.is-guest[data-step="${step}"]`);
    let printStatus = $('#print-name');
    let answer = $(`.chatbot-answer[data-step="${step}"]`);
    let answerInput = answer.find('input');
    let answerButton = answer.find('button');

    bot.show();

    if (!isNamed) {
      new Typed('#type-name', {
        stringsElement: '#text-name',
        typeSpeed: 10,
        backSpeed: 20,
        startDelay: 1000,
        loop: false,
        onBegin: function (self) {
          setTimeout(() => printStatus.show(), self.startDelay);
        },
        onComplete: function () {
          printStatus.hide();
          answer.fadeIn();
          scrollToBot();
        },
      });
    }

    isNamed = true;

    answerButton.on('click', () => {
      guestName.val(answerInput.val());
      answer.hide();
      user.show();
      guest.name = answerInput.val();
      scrollToBot();
      go();
    });
  }

  function thxUser() {
    let userName = $('#user-name');
    let bot = $(`.is-bot[data-step="thx"]`);
    let printStatus = $('#print-thx');

    userName.text(guest.name);
    bot.show();

    if (!isThxed) {
      new Typed('#type-thx', {
        stringsElement: '#text-thx',
        typeSpeed: 10,
        backSpeed: 20,
        startDelay: 1000,
        loop: false,
        onBegin: function (self) {
          setTimeout(() => printStatus.show(), self.startDelay);
        },
        onComplete: function () {
          printStatus.hide();
          scrollToBot();
        },
      });
    }
    isThxed = true;
  }

  function scrollToBot() {
    let area = $('.simplebar-content-wrapper');
    let content = $('.simplebar-content');

    area.animate({ scrollTop: content.height() }, 1000);
  }

  function addAdult() {
    adults++;
    persons = adults + kids;
    adults > 1
      ? minusButton.removeClass('is-disabled')
      : minusButton.addClass('is-disabled');
    adultVal.text(adults);
    personsAnswer.val(getCountGuests(persons));
    submitPersonsButton.show();
  }

  function removeAdult() {
    if (adults > 1) adults--;
    persons = adults + kids;
    adults > 1
      ? minusButton.removeClass('is-disabled')
      : minusButton.addClass('is-disabled');
    adultVal.text(adults);
    personsAnswer.val(getCountGuests(persons));
    submitPersonsButton.show();
  }

  function addKid() {
    kids++;
    kids > 3 ? addKidButton.hide() : addKidButton.show();
    persons = adults + kids;
    kidsAge.slideDown(300);
    submitPersonsButton.show();
  }

  function showAddedKid(age) {
    let kid = `<div class="chatbot-kid" style="display: none;">
                      <div class="chatbot-kid__title">Ребенок</div>
                      <div class="chatbot-kid-info">
                        <div class="chatbot-kid__age">${getCountKids(age)}</div>
                        <div class="chatbot-kid__remove js-removeKid"></div>
                      </div>
                    </div>`;

    kidsAge.slideUp(300);
    kidsTable.append(kid);
    personsAnswer.val(getCountGuests(persons));
    setTimeout(() => $('.chatbot-kid:last-child').slideDown(300), 300);
  }

  function removeAddedKid(kid) {
    kids--;
    kids > 3 ? addKidButton.hide() : addKidButton.show();
    persons = adults + kids;
    kid.slideUp(300);
    personsAnswer.val(getCountGuests(persons));
    setTimeout(() => kid.remove(), 300);
    submitPersonsButton.show();
  }

  function submitPersons() {
    let user = $(`.is-guest[data-step="persons"]`);

    guest.persons = {
      adults: adults,
      kids: kids,
      total: persons,
    };

    submitPersonsButton.hide();
    user.show();

    go();
  }

  function sendUserData() {
    if (!isSent) {
      // console.log(guest);
      // $.ajax({
      //   type: 'POST',
      //   url: '',
      //   data: JSON.stringify(guest),
      //   contentType: 'application/json; charset=utf-8',
      //   dataType: 'json',
      //   success: function (data) {
      //     alert(data);
      //   },
      //   error: function (errMsg) {
      //     alert(errMsg);
      //   },
      // });
    }
    isSent = true;
  }

  function declinationGuests(number, titles) {
    let cases = [2, 0, 1, 1, 1, 2];
    return titles[
      number % 100 > 4 && number % 100 < 20
        ? 2
        : cases[number % 10 < 5 ? number % 10 : 5]
    ];
  }

  // события
  $('.js-addAdult').on('click', () => addAdult());
  $('.js-removeAdult').on('click', () => removeAdult());
  $('.js-addKid').on('click', () => addKid());
  $('.js-removeKid').on('click', () => removeKid());
  $('.js-submitPersons').on('click', () => submitPersons());

  $('.chatbot-kids__year').on('click', function () {
    let kidAge = $(this).text();

    showAddedKid(kidAge);
  });

  $(document).on('click', '.js-removeKid', function () {
    let currentKid = $(this).closest('.chatbot-kid');

    removeAddedKid(currentKid);
  });

  $('#phone-answer').on('keyup blur change', function () {
    $(this).val().length === 18 && $(this).val().slice(-1) !== '_'
      ? $(this).siblings('button').removeClass('is-disabled')
      : $(this).siblings('button').addClass('is-disabled');
  });

  $('#name-answer').on('keyup blur change', function () {
    $(this).val().length > 0
      ? $(this).siblings('button').removeClass('is-disabled')
      : $(this).siblings('button').addClass('is-disabled');
  });

  //
}

$(window).on('load', () => {
  setTimeout(() => {
    if (!chat.hasClass('on')) $('.js-chatbot').trigger('click');
  }, startTime);
});

$('.js-chatbot').on('click', () => {
  chat.addClass('on');
  chatBot();
});
$('.js-closeChatBot').on('click', () => chat.removeClass('on'));
